



















import {Component, Emit, Model, Prop, Vue} from "vue-property-decorator";
import {enumToOptions} from "@/shared/services/helper/utils";
import {EnumOption} from "@/interfaces/common";
import EnumLabel from "@/shared/components/EnumSelector/components/Label.vue";

@Component({
    name: "EnumSelector",
    components: {EnumLabel}
})
export default class extends Vue {
    @Prop({ default: false })
    readonly disabled!: boolean;

    @Prop({ default: 'default' })
    readonly size!: string;

    @Prop({ type: String, required: true })
    readonly placeholder!: string;

    @Prop({ type: Boolean, default: false })
    readonly allowClear!: boolean;

    @Prop({ type: Object, required: true })
    readonly enumInstance!: object;

    @Prop({ type: String, default: "" })
    readonly enumNamed!: string;

    @Prop({ type: Array, default: () => [] })
    readonly limit!: any;

    @Prop({ type: Array, default: () => [] })
    readonly except!: any;

    @Model("change", { required: true })
    readonly valueSelected!: number|string;

    @Emit("change")
    handleChange(value: number|string) {
        return value;
    }

    get options(): EnumOption[] {
        if (this.limit && this.limit?.length)
            return enumToOptions(this.enumInstance).filter((option: EnumOption) => this.limit.includes(option.value));
        if (this.except && this.except?.length)
            return enumToOptions(this.enumInstance).filter((option: EnumOption) => !this.except.includes(option.value))
        return enumToOptions(this.enumInstance);
    }
}
